export default "/images/logo-9.png?c8597a271e26f9adaa19ee0a8472cec9";